import Ship from './ship.js';

export default class Submarine extends Ship {
  constructor() {
    super(3, 'submarine');
  }
}
